import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconGrid = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconGrid.dimensions.width} ${IconGrid.dimensions.height}`}
      {...otherProps}
    >
      <G stroke={color || Color.premiumBlack} fill="none" fillRule="evenodd">
        <Path d="M1 1h8v8H1zM1 12h8v8H1zM12 1h8v8h-8zM12 12h8v8h-8z" />
      </G>
    </Svg>
  )
}

IconGrid.dimensions = {
  width: 21,
  height: 21,
}

export default IconGrid
